import type { RefreshableQueryOptions } from "Context/SynchronizationContext";
import { useApi } from "Domain/Api";
import type { FileProfile } from "Types/File";
import { useRefreshableQuery } from "Hooks";

export default function useProfileQuery(options: RefreshableQueryOptions = { showSynchronizationStatus: false }) {
  const api = useApi();

  return useRefreshableQuery<FileProfile>(
    api.getQueryKey(["profile"]),
    () => api.get(`file/v1/profile`).then((resp) => resp.json()),
    options,
  );
}
